import { Row, Col, Table } from "react-bootstrap";

import { tableHead, header_table } from "./createReturn.module.scss";

const CreateReturnTableHead = () => {
	return (
		<Row className={header_table}>
			<Col md={12} sm={12}>
				<Table className={tableHead}>
					<thead>
						<tr>
							<th style={{ width: "3%" }}>#</th>
							<th style={{ width: "19%" }}>Código</th>
							<th style={{ width: "20%" }}>Producto</th>
							<th style={{ width: "15%" }}>Contenido por Envase</th>
							<th style={{ width: "10%" }}>U.M.</th>
							<th style={{ width: "10%" }}>Precio</th>
							<th style={{ width: "10%" }}>Cantidad</th>
							<th style={{ width: "10%" }}>Cantidad Devolución</th>
							<th style={{ width: "3%" }}></th>
						</tr>
					</thead>
				</Table>
			</Col>
		</Row>
	);
};

export default CreateReturnTableHead;
